import React from 'react';
import { IconBaseProps } from 'react-icons';

import { ReactComponent as IntegrationIconSvg } from './integration.svg';

export default function IntegrationIcon({ size, ...props }: IconBaseProps) {
  return <IntegrationIconSvg width={size || 18} height={size || 18} {...props} />;
}